import { render, staticRenderFns } from "./SupplierNotificationsPage.vue?vue&type=template&id=4b019076&"
import script from "./SupplierNotificationsPage.js?vue&type=script&lang=js&"
export * from "./SupplierNotificationsPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports